// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4c2fca65","30":"46160254","186":"e0d6135e","225":"327aa19d","272":"4809852c","372":"89afc611","573":"8d42906a","738":"af7e040a","787":"cbb1e651","841":"58bbcc95","856":"f3cf8814"}[chunkId] + ".chunk.js";
};